fragment IncontentImageRowFragment on inContentImageRow_Entry {
  typeHandle
  sets {
    ... on imageRowSetBlock_Entry {
      image {
        url
        title
      }
      alt
      caption
    }
  }
}
